import classNames from "classnames"

export default function DefaultOption({ option, isSelected, isActive }) {
  return (
    <div
      className={classNames("cursor-pointer truncate p-2 hover:bg-primary-10", {
        "bg-primary-10": isSelected || isActive,
      })}
    >
      {option.label}
    </div>
  )
}
